import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class WebsiteErrorManager implements ErrorHandler {
    handleError(error: any) {
        console.error(error);
    }
}
